<template>
  <div>
    <Popup
      :zIndex="99"
      :raduis="false"
      :title="gettext('选择城市')"
      v-model="show"
      @cancel="close"
      :ratio="90"
      v-if="visible"
    >
      <city-picker :cityData="cityData" @cityChange="cityChange" />
    </Popup>
    <Popup
      :zIndex="99"
      :raduis="false"
      :title="gettext('选择商圈')"
      v-model="show"
      @cancel="close"
      :hideTilte="true"
      :ratio="90"
      cancel-txt=""
      confirmTxt=""
      v-else
    >
      <area-tree
        :options="areaData"
        @areaChange="areaChange"
        @cityPopupShow="cityPopupShow"
      />
      <div class="area-picker_bottom">
        <rich-button
          class="area-picker-btn"
          :primary="true"
          :disabled="checkedData.length < 1"
          @click="confirmAreaChecked"
          >确定</rich-button
        >
      </div>
    </Popup>
  </div>
</template>
<script>
import { Popup } from '@/formily/src'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import CityPicker from './cityPicker.vue'
import AreaTree from './areaTree.vue'
const namespace = 'bizoppV2'
export default {
  name: 'cityAreaPicker',
  components: { CityPicker, Popup, AreaTree },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      cityData: [],
      visible: true,
      // areaData: [],
      checkedData: []
    }
  },
  computed: {
    ...mapState(['geo']),
    ...mapState(namespace, {
      areaCityAreaTree: (state) => state.areaCityAreaTree || [],
      areaChecked: (state) => state.areaChecked || [],
      areaCityChecked: (state) => state.areaCityChecked,
      allFilterParams: (state) => state.allFilterParams
    }),
    areaData() {
      const { children = [] } = this.areaCityAreaTree.find((item) => {
        return item.id === this.areaCityChecked.value
      })
      return children
    }
  },

  created() {
    this.getDataByareaTab()
    this.init()
  },
  watch: {
    show: {
      immediate: true,
      handler(v) {
        if (!v) {
          if (this.areaCityChecked.value) {
            this.visible = false
          } else {
            this.visible = true
          }
        }
        this.checkedData = this.areaChecked
        // if (!v) {
        //   if (this.areaCityChecked.value) {
        //     this.visible = true
        //   } else {
        //     this.visible = true
        //   }
        // } else {
        //   this.checkedData = this.areaChecked
        //   this.visible = false
        // }
        // console.log(this.visible, 'this.visible')
      }
    },
    visible(v) {
      console.log(v, 'visible')
    }
  },
  methods: {
    ...mapMutations(namespace, ['updateAreaChecked', 'updateAllFilterParams']),
    ...mapActions(namespace, ['getAreaTreeByArea']),
    init() {
      if (this.areaCityChecked && this.areaCityChecked.value) {
        this.visible = false
      }
    },
    // 获取城市商圈的数据
    async getDataByareaTab() {
      await this.getAreaTreeByArea()
      await this.getCityOptions()
    },
    // 获取城市数据
    getCityOptions() {
      if (this.areaCityAreaTree.length) {
        let citydata = []
        this.areaCityAreaTree.map((item) => {
          citydata.push({
            label: item.label,
            value: item.id
          })
        })
        this.cityData = citydata
      }
    },
    // 选择城市后出商圈选择数据和弹层
    cityChange(val) {
      if (!val) return
      this.visible = false
      // const data = this.areaCityAreaTree.find((item) => {
      //   return item.id === val
      // })
      // this.areaData = data.children
    },
    areaChange(val) {
      this.checkedData = val

      // this.updateAreaChecked(val)
    },
    // 取消的时候，要清空城市的数据和UI的选择态
    close() {
      this.$emit('cancel')
    },
    confirm() {
      // this.updateAreaChecked(this.checkedData)
      this.$emit('cancel')
    },
    // 展示城市
    cityPopupShow() {
      this.visible = true
    },
    // 商圈选择确认
    confirmAreaChecked() {
      this.updateAreaChecked(this.checkedData)
      this.updateAllFilterParams({
        ...this.allFilterParams,
        commnoAreaCheckedIds: this.areacheckedIds
      })
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.area-picker_bottom {
  padding: 20px 24px 40px 24px;
  background: #ffffff;
  box-sizing: content-box;
  box-shadow: 0 12px 80px 0 rgba(0, 0, 0, 0.08);
  border-radius: 0 0 12px 12px;
  position: fixed;
  bottom: 0;
  .area-picker-btn {
    width: calc(100vw - 48px);
  }
}
</style>
